import React, { useContext } from 'react';
import Drag from './Drag';
import { AppContext } from '../../context/app.context';
import { IonItem, IonLabel, IonIcon } from '@ionic/react';
import { QuestionnaireActionTypes } from '../../reducers/questionnaire.reducer';
import { getIcon } from 'misc/utils';
import { HealthIssueType } from 'models/health-issue-type.model';

const ProcAttribDrag = React.memo((props: {
    preset: string
}) => {
    const appContext = useContext(AppContext);

    const selectGroup = (type: string, item: any) => {
        appContext.updateQuestionnaire(type, item);
    }

    return (
        <div className="drag-drop-container">

            {props.preset === 'procattribs' && !appContext.questionnaire?.GroupSelected &&
                appContext.lookup && appContext.lookup.ProcAttribGroups && appContext.lookup.ProcAttribGroups.filter(f =>  f.ProcAttribCategoryID === 1  &&  f.Name.toLowerCase().indexOf(appContext.questionnaire?.SearchedText?.toLowerCase()) > -1)
                    .sort((a, b) => a.Name.localeCompare(b.Name))
                    .map((item, index) => (
                        <IonItem button detail onClick={() => selectGroup(QuestionnaireActionTypes.SELECT_GROUP, item)} className="pointer" key={index}>
                            <IonLabel title={item.Label} className="procAttribLabel ion-no-margin">
                                {item.Name}
                            </IonLabel>
                        </IonItem>
                    ))
            }
            <div hidden={props.preset !== 'procattribs'}>
                {appContext.questionnaire?.GroupSelected && appContext.lookup?.ProcAttribTypes?.filter(
                    f => (f.ProcAttribTypeID + f.Name + f.Label).toUpperCase().includes(appContext.questionnaire?.SearchedText.toUpperCase()) && f.ProcAttribGroupID === appContext.questionnaire.GroupSelected.ProcAttribGroupID)
                    .sort((a, b) => a.Name.localeCompare(b.Name))
                    .map((item, index) => (
                        <Drag key={index} type="procattrib" dataItem={item} dragImage="" dropEffect="link">
                            <IonItem className="pointer" title={ item.SubGroup + " " + item.Label }>
                                <IonIcon size="small" className="mr-1" icon={getIcon(item.UIControlType)} color="primary"/>
                                <IonLabel className="procAttribLabel ion-no-margin">
                                     {item.Label} 
                                </IonLabel>
                            </IonItem>
                        </Drag>
                    ))
                }
            </div>
            <div hidden={props.preset !== 'healthissues'}>
                {appContext.lookup?.HealthIssueTypes
                    ?.filter((f:HealthIssueType) => (f.HealthIssueTypeID + f.Description)?.toLowerCase().indexOf(appContext.questionnaire?.SearchedText) > -1)
                    .sort((a, b) => a.Description.localeCompare(b.Description))
                    .map((item, index) => (
                        <Drag key={index} type="healthissue" dataItem={item} dragImage="" dropEffect="link">
                            <IonItem className="pointer" title={ item.SubGroup + " - " + item.Description }>
                                <IonLabel className="procAttribLabel ion-no-margin">
                                    {item.HealthIssueTypeID + " - " + item.Description}
                                </IonLabel>
                            </IonItem>
                        </Drag>
                    ))
                }
            </div>
            
        </div>
    )
});

export default ProcAttribDrag;